import _ from 'lodash'

// If/when Rendition Billing V1 is deprecated, simply remove RB_V1_CONFIG and refactor RB_V2_CONFIG constants

/**
 * Config for Rendition Billing V1
 */
export const RB_V1_CONFIG = {
  invoiceOptions: [
    { label: 'Invoice canceled', value: 'Invoice canceled' },
    { label: 'Awaiting documents', value: 'Awaiting documents' },
    { label: 'Invoice ready', value: 'Invoice ready' },
    { label: 'Invoice sent', value: 'Invoice sent' },
    { label: 'Invoice send failed', value: 'Invoice send failed' },
    { label: 'Invoice archived', value: 'Invoice archived' },
  ],
  INVOICE_CUSTOMER_PATH: 'rbInvoice.customer.entityId',
  INVOICE_NUMBER_PATH: 'rbInvoice.invoiceNumber',
  INVOICE_ORDERS_PATH: 'rbInvoice.orders',
  INVOICE_STATUS_PATH: 'rbInvoice.invoiceStatus'
}

/**
 * Config for Rendition Billing V2
 */
export const INVOICE_PATH = 'core_accounting_accountsReceivable_salesInvoice'
export const CONSOLIDATED_SALES_INVOICE_PATH = 'core_accounting_accountsReceivable_consolidatedSalesInvoice'
export const INVOICE_ENTITY_TYPE = "/1.0/entities/metadata/core_accounting_accountsReceivable_salesInvoice.json"
export const INVOICE_REQUIREMENTS_PATH = `${INVOICE_PATH}.readyToInvoice.requirements`
export const RB_V2_CONFIG = {
  invoiceOptions: [
    { label: 'Pending', value: 'Pending' },
    { label: 'Submitted', value: 'Submitted' },
    { label: 'Sent', value: 'Sent' },
    { label: 'Archived', value: 'Archived' },
    { label: 'Canceled', value: 'Canceled' }
  ],
  INVOICE_CUSTOMER_PATH: `${INVOICE_PATH}.billTo.entityId`,
  INVOICE_NUMBER_PATH: `${INVOICE_PATH}.invoiceNumber`,
  INVOICE_ORDERS_PATH: `${INVOICE_PATH}.order`,
  INVOICE_STATUS_PATH: `${INVOICE_PATH}.stage`
}

export const ORDER_PATH = 'core_fulfilment_salesOrder'
export const ORDER_ENTITY_TYPE = `/1.0/entities/metadata/${ORDER_PATH}.json`

export const CONSOLIDATED_SALES_INVOICE_ID = '8143804c-541b-4979-928f-b48ff78643dc'
export const TMW_SALES_INVOICE_ID = '946facf0-28d6-4416-9e04-5baa9d9589b0'
export const TIGERLINES_FIRM_ID = 'bf6a36f7-c417-47ea-8b2b-1697694e4bde'
export const TIGERLINES_LEGACY_RB_CUTOFF = '2026-04-09T00:00:00Z'
export const TIGERLINES_LEGACY_RB_SALES_ORDER_ID = 'd19ff629-eaab-40e1-b374-3a57b3bdf11e'
export const TIGERLINES_LEGACY_RB_SALES_INVOICE_ID = 'e4cf9cd3-c4ab-4ff4-b23e-52d1cc1ca9c4'
export const TIGERLINES_LEGACY_RB_CONSOLIDATED_SALES_INVOICE_ID = '08718b0c-2b1c-4353-8886-4069267be43f'

const hasMixin = (entity, mixinId: string) => _.some(_.get(entity, 'mixins.active'), { entityId: mixinId })
const isPreCutoffTigerLines = (entity) => _.get(entity, 'owner.firm.entityId') === TIGERLINES_FIRM_ID
  && !_.isEmpty(_.get(entity, 'creationDate'))
  && new Date(_.get(entity, 'creationDate')).getTime() < new Date(TIGERLINES_LEGACY_RB_CUTOFF).getTime()

export const isLegacyTigerLinesRbSalesOrder = (entity) =>
  hasMixin(entity, TIGERLINES_LEGACY_RB_SALES_ORDER_ID) || isPreCutoffTigerLines(entity)

export const isLegacyTigerLinesRbSalesInvoice = (entity) =>
  hasMixin(entity, TIGERLINES_LEGACY_RB_SALES_INVOICE_ID) || isPreCutoffTigerLines(entity)

export const isLegacyTigerLinesRbConsolidatedSalesInvoice = (entity) =>
  hasMixin(entity, TIGERLINES_LEGACY_RB_CONSOLIDATED_SALES_INVOICE_ID) || isPreCutoffTigerLines(entity)
